export function clearLogas() {
    // clear localStorage of previous logas ids
    localStorage.removeItem("side_team_activeOrganisationId");
    localStorage.removeItem("side_team_groupId");
    localStorage.removeItem("side_team_logasId");
    localStorage.removeItem("side_team_logas_email");
}
